// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__f1OQa","createdSearch":"index_createdSearch__BXd2e","custom_table":"index_custom_table__KKScZ"};